import { cleanObject, randomId } from '@shared/utils';
import getPieveRuntimeInstanceHeader from '@/lib/apps/getPieveRuntimeInstanceHeader.js';
import { post } from '@/redux/requests/api.js';

const buildRunRequestHeaders = () => {
  return {
    'x-mindcloud-instance': getPieveRuntimeInstanceHeader(),
    'x-pieve-request-nonce': randomId(),
    'x-pieve-request-timestamp': String(Math.floor(Date.now() / 1000))
  };
};

const startThreadRun = ({ threadId, idempotencyKey, newUserMessage, newUserInput, eventUpdate, model, reasoning, runtime, client, signal } = {}, callback) => {
  const data = cleanObject({ idempotencyKey, newUserMessage, newUserInput, eventUpdate, model, reasoning, runtime, client });

  if (import.meta.env.DEV) {
    data.timestamp = new Date().toISOString();
  }

  return post(`/v1/pieve/threads/${encodeURIComponent(threadId)}/runs`, {
    signal,
    callback,
    headers: buildRunRequestHeaders(),
    data
  });
};

const steerThreadRun = ({ threadId, runId, expectedRunId, input, idempotencyKey, signal } = {}, callback) => {
  return post(`/v1/pieve/threads/${encodeURIComponent(threadId)}/runs/${encodeURIComponent(runId)}/steer`, {
    signal,
    callback,
    headers: buildRunRequestHeaders(),
    data: cleanObject({ expectedRunId, input, idempotencyKey })
  });
};

const cancelThreadRun = ({ threadId, runId, signal } = {}, callback) => {
  return post(`/v1/pieve/threads/${encodeURIComponent(threadId)}/runs/${encodeURIComponent(runId)}/cancel`, {
    signal,
    callback,
    headers: buildRunRequestHeaders()
  });
};

export { cancelThreadRun, startThreadRun, steerThreadRun };
